import { useMemo } from "react";
import { ContainerData } from "features/shared/OpenedCardEvents/types";
import { createSeaEvents } from "features/shared/OpenedCardEvents/utils";
import { SeaSearchCardModel } from "entities/SeaSearchCard";
import { Nullable } from "shared/lib/typeCheck.lib";

export const useOpenedCardContainers = (model?: Nullable<SeaSearchCardModel>): ContainerData[] => {
  return useMemo(() => {
    const containers = model?.containers;
    if (!containers) return [];

    return containers.map((container) => {
      return {
        number: container.number,
        events: createSeaEvents(model?.getTransformedEvents(container.events)),
      };
    });
  }, [model?.rawData]);
};
